/* global document */

export function readCookie(n) {
  let a = document.cookie;
  let cookiewert = '';
  let res = '';
  while (a !== '') {
    while (a.substr(0, 1) === ' ') {
      a = a.substr(1, a.length);
    }
    const cookiename = a.substring(0, a.indexOf('='));

    if (a.indexOf(';') !== -1) {
      cookiewert = a.substring(a.indexOf('=') + 1, a.indexOf(';'));
    } else {
      cookiewert = a.substr(a.indexOf('=') + 1, a.length);
    }
    if (n === cookiename) {
      res = cookiewert;
    }
    let i = a.indexOf(';') + 1;
    if (i === 0) {
      i = a.length;
    }
    a = a.substring(i, a.length);
  }
  return (res.split(' '));
}

export function createCookie(name, value, days, projectLimit) {
  const cV = ` ${value} `;
  let expires;
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toGMTString()}`;
  } else expires = '';

  // Cookies für die einzelnen Homepages bei "zuletzt angesehen"

  if (name === 'last_seen') {
    const currentCookieValue = readCookie(name);
    /* Die Variable  checkIfDuplicate speichert den Zustand zur Prüfung ob eine
    Projekt ID bereits vorhanden ist */
    const checkIfDuplicate = currentCookieValue.indexOf(value) !== -1;
    if (!checkIfDuplicate) { // wenn die Funktion true zurückliefert ist der Wert schon vorhanden
      if (currentCookieValue.length > projectLimit) {
        currentCookieValue.shift();
        document.cookie = `${name}= ${cV.replace('undefined', '')}${currentCookieValue.join(' ')}${expires}; path=/; SameSite=Strict`;
      } else {
        document.cookie = `${name}= ${cV.replace('undefined', '')}${currentCookieValue.join(' ')}${expires}; path=/; SameSite=Strict`;
      }
    }
  }

  if (name === 'list_cookie') {
    const currentCookieValue = readCookie(name);
    const checkIfDuplicate = currentCookieValue.indexOf(value) !== -1;
    if (!checkIfDuplicate) { // wenn die Funktion true zurückliefert ist der Wert schon vorhanden
      if (currentCookieValue.length > projectLimit) {
        currentCookieValue.shift();
        document.cookie = `${name}= ${cV.replace('undefined', '')}${currentCookieValue.join(' ')}${expires}; path=/; SameSite=Strict`;
      } else {
        document.cookie = `${name}= ${cV.replace('undefined', '')}${currentCookieValue.join(' ')}${expires}; path=/; SameSite=Strict`;
      }
    }
  }

  if (name === 'empfohlen_cookie') { // schlägt empfohlene Projekte vor
    const currentCookieValue = readCookie(name);
    const checkIfDuplicate = currentCookieValue.indexOf(value) !== -1;
    if (!checkIfDuplicate) { // wenn die Funktion true zurückliefert ist der Wert schon vorhanden
      if (currentCookieValue.length > projectLimit) {
        currentCookieValue.shift();
        document.cookie = `${name}= ${cV.replace('undefined', '')}${currentCookieValue.join(' ')}${expires}; path=/; SameSite=Strict`;
      } else {
        document.cookie = `${name}= ${cV.replace('undefined', '')}${currentCookieValue.join(' ')}${expires}; path=/; SameSite=Strict`;
      }
    }
  }
}

export function deleteFromCookie(name, value) {
  const cookieToDelete = readCookie(name);
  const indexOfCookieToDelete = cookieToDelete.indexOf(value);

  if (name === 'list_cookie') {
    cookieToDelete.splice(indexOfCookieToDelete, 1);
    const checkIfDuplicate = cookieToDelete.indexOf(value) !== -1;
    if (!checkIfDuplicate) {
      document.cookie = `${name}= ${cookieToDelete.join(' ')}; path=/; SameSite=Strict`;
    }
  }
}
